import React from 'react';
import './Separator.scss';

export type SeparatorProps = {
    fullWidth?: boolean;
    noTopSpacing?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Separator: React.FC<SeparatorProps> = ({ className, fullWidth, noTopSpacing, ...props }) => {
    return <div className={`separator ${className ?? ''}`} data-full-width={fullWidth} data-no-top-spacing={noTopSpacing} {...props}></div>;
};
